// Add favorites functionality
document.querySelectorAll('.favourites-button-container').forEach(container => {
    const button = container.querySelector('.favourite-button');
    
    button.addEventListener('click', function(event) { 
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const data = {
            elementId: container.dataset.variantId,
            elementSiteId: container.dataset.siteId,
            action: container.dataset.action
        };

        // Add CSRF token
        data[container.dataset.csrfName] = container.dataset.csrfToken;

        fetch('/', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new URLSearchParams(data)
        })
        .then(response => response.json())
        .then(response => {
            if (response.success) {
                // Toggle button state
                button.classList.toggle('active');
                
                // Update action for next click
                container.dataset.action = container.dataset.action === 'wishlist/items/add' 
                    ? 'wishlist/items/remove' 
                    : 'wishlist/items/add';
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    });
});